// @flow
import type { JobFunctions } from 'api/orgs';
import type { Action } from '../actions/jobFunctions';

export type State = ?JobFunctions;

export default function jobFunctions(state: State = null, action: Action) {
  switch (action.type) {
    case 'JOB_FUNCTIONS_SET': {
      return action.jobFunctions;
    }

    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
